import React, { useState } from 'react';
import styled from 'styled-components';
import MiniPopup from '../../MiniPopup';
const ToolbarStyle = {
  Contain: styled.div`
    position: absolute;
    right: 20px;
    top: 116px;
    z-index: 1;
  `,
  Wrap: styled.div`
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  `,
  List: styled.ul`
    border-radius: 50px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #ddd;
    box-shadow: 2px 4px 6px 0 #00000040;
  `,
  Item: styled.li<{ $ico?: string; $icoActive?: string }>`
    position: relative;

    &:not(:last-child) {
      border-bottom: 1px solid #ccc;
    }
    &:first-child {
      > button {
        border-radius: 50px 50px 0 0;
      }
    }
    &:last-child {
      > button {
        border-radius: 0 0 50px 50px;
      }
    }
    span {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s;
      font-size: 12px;
      font-weight: 500;
      background: rgba(0, 0, 0, 0.7);
      border: 1px solid #7a7c7f;
      color: #fff;
      padding: 3px 6px;
      border-radius: 4px;
      word-break: keep-all;
      &:after {
        position: absolute;
        left: 100%;
        top: 50%;
        content: '';
        transform: rotate(135deg) translate(0, 70%);
        border: 4px solid transparent;
        border-top: 4px solid rgba(122, 124, 127, 0.7);
        border-left: 4px solid rgba(122, 124, 127, 0.7);
      }
      &:before {
        position: absolute;
        left: 100%;
        top: 50%;
        content: '';
        transform: rotate(135deg) translate(0, 70%);
        z-index: 2;
        border: 3px solid transparent;
        border-top: 3px solid rgba(0, 0, 0, 0.4);
        border-left: 3px solid rgba(0, 0, 0, 0.4);
      }
    }

    &.active {
      > button {
        background-color: #d9f2ef;
        ${(p) => p.$ico && `background-image:url(${p.$icoActive});`}
      }
    }
  `,
  ItemButton: styled.button<{ $ico: string }>`
    position: relative;
    width: 46px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-align: center;
    background-repeat: no-repeat;
    background-position: center;
    ${(p) => p.$ico && `background-image:url(${p.$ico});`}
    &:hover {
      span {
        opacity: 1;
        visibility: visible;
        right: calc(100% + 5px);
        top: 50%;
      }
    }
  `,
  ItemCont: styled.ul`
    border-radius: 12px;
    overflow: hidden;
  `,
  ItemContItem: styled.li`
    text-align: center;
    height: 48px;
    line-height: 48px;
    color: #192640;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    &:hover,
    &.active {
      background: #f2f8f9;
      font-weight: 600;
    }
  `,
};
const Toolbar = ({ toolList, setToolList, mapInstance, setProperty, setMeasureStatus, setMeasureType }) => {
  const [popState, setPopState] = useState({
    mapType: false,
    search: false,
  });
  const [mapTypeList, setMapTypeList] = useState([
    { id: 0, name: '일반 지도', active: false },
    { id: 1, name: '위성 지도', active: true },
    { id: 2, name: '구글 위성 맵', active: false },
    // { id: 3, name: '기본 맵', active: false },
    // { id: 4, name: 'Terrain 맵', active: false },
    // { id: 5, name: '변경된 로드맵', active: false },
    { id: 6, name: '하이브리드 맵', active: false },
  ]);

  //툴바 버튼 클릭 토글
  const onToolbarClick = (id: number) => {
    const newArr = [...toolList];
    if (id === 0) {
      newArr.filter((i) => i.id === 0)[0].active = !newArr.filter((i) => i.id === 0)[0].active;
    } else if (
      //지적도 클릭
      id === 1
    ) {
      if (!newArr.filter((i) => i.id === 1)[0].active) {
        setProperty({});
      }
      newArr.filter((i) => i.id === 1)[0].active = !newArr.filter((i) => i.id === 1)[0].active;
    } else if (id === 2 || id === 3) {
      //거리 or 면적 클릭(상호작용)
      newArr
        .filter((i) => i.id === 2 || i.id === 3)
        .map((i) => {
          if (i.id === id) {
            if (i.active) {
              i.active = false;
              setMeasureStatus(false);
            } else {
              i.active = true;
              setMeasureType(i.id === 2 ? 'LineString' : 'Polygon');
              setMeasureStatus(true);
            }
          } else {
            i.active = false;
          }
        });
    }
    // objectSite?.onCloseCluster();

    setToolList(newArr);
  };

  // 지도 전환
  const onChangeMapType = (id: number) => {
    const newArr = [...mapTypeList];
    newArr.map((i) => {
      i.active = i.id === id;
    });
    setMapTypeList(newArr);
    setToolList((prevState) => {
      const newArr = [...prevState];
      newArr.filter((i) => i.id === 0)[0].active = false;
      return newArr;
    });
    setPopState({
      ...popState,
      mapType: false,
    });
    id === 0
      ? mapInstance?.mapChange(mapInstance!.vWorldBaseSource)
      : id === 1
        ? mapInstance?.mapChange(mapInstance!.vWorldSatelliteSource)
        : id === 2
          ? mapInstance?.mapChange(mapInstance!.googleMapSource)
          : //   : id === 3
            //     ? mapInstance?.mapChange(mapInstance!.standardMapSource)
            //     : id === 4
            //       ? mapInstance?.mapChange(mapInstance!.terrainMapSource)
            //       : id === 5
            //         ? mapInstance?.mapChange(mapInstance!.sarMapSource)
            mapInstance?.mapChange(mapInstance!.vWorldHybridSource);
  };

  return (
    <ToolbarStyle.Contain>
      <ToolbarStyle.Wrap>
        <ToolbarStyle.List>
          {toolList
            .filter((i) => i.id === 0 || i.id === 1)
            .map((i) => {
              return (
                <ToolbarStyle.Item key={i.name} className={i.active ? 'active' : undefined} $ico={i.ico} $icoActive={i.icoActive}>
                  <ToolbarStyle.ItemButton
                    $ico={i.ico}
                    type={'button'}
                    onClick={() => {
                      onToolbarClick(i.id);
                      if (i.id === 0) {
                        setPopState({ ...popState, mapType: !popState.mapType });
                      }
                    }}
                  >
                    <span>{i.name}</span>
                  </ToolbarStyle.ItemButton>

                  {i.id === 0 && popState.mapType && (
                    <MiniPopup right={76} top={-19} width={113} $arrowTop={34} padding={[0]}>
                      <ToolbarStyle.ItemCont>
                        {mapTypeList.map((i) => {
                          return (
                            <ToolbarStyle.ItemContItem className={i.active ? 'active' : undefined} onClick={() => onChangeMapType(i.id)}>
                              {i.name}
                            </ToolbarStyle.ItemContItem>
                          );
                        })}
                      </ToolbarStyle.ItemCont>
                    </MiniPopup>
                  )}
                </ToolbarStyle.Item>
              );
            })}
        </ToolbarStyle.List>
      </ToolbarStyle.Wrap>
      <ToolbarStyle.Wrap>
        <ToolbarStyle.List>
          {toolList
            .filter((i) => i.id !== 0 && i.id !== 1)
            .map((i) => {
              return (
                <ToolbarStyle.Item key={i.name} className={i.active ? 'active' : undefined} $ico={i.ico} $icoActive={i.icoActive}>
                  <ToolbarStyle.ItemButton $ico={i.ico} type={'button'} onClick={() => onToolbarClick(i.id)}>
                    <span>{i.name}</span>
                  </ToolbarStyle.ItemButton>
                  {i.id === 4 && popState.search && (
                    <MiniPopup right={76} top={-19} width={113} $arrowTop={34} padding={[0]}>
                      <ToolbarStyle.ItemCont>
                        <ToolbarStyle.ItemContItem>개별조회</ToolbarStyle.ItemContItem>
                        <ToolbarStyle.ItemContItem>다중조회</ToolbarStyle.ItemContItem>
                      </ToolbarStyle.ItemCont>
                    </MiniPopup>
                  )}
                </ToolbarStyle.Item>
              );
            })}
        </ToolbarStyle.List>
      </ToolbarStyle.Wrap>
    </ToolbarStyle.Contain>
  );
};

export default Toolbar;
